import {
    SETTINGS_SEO_LISTING_DESCRIPTION,
    SETTINGS_SEO_LISTING_TITLE,
    SETTINGS_SEO_PRODUCT_DESCRIPTION,
    SETTINGS_SEO_PRODUCT_TITLE,
    SETTINGS_SEO_STATIC_DESCRIPTION,
    SETTINGS_SEO_STATIC_TITLE,
} from '../../constants';
import { type SettingSeoPaths } from '../hooks/useSettingsSeo';

const PLACEHOLDER_MAPPING = new Map<SettingSeoPaths, string>([
    [SETTINGS_SEO_PRODUCT_TITLE, '[TITLE] – купить в интернет-магазине: фото, характеристики, описание.'],
    [
        SETTINGS_SEO_PRODUCT_DESCRIPTION,
        '[TITLE] в официальном интернет-магазине. Подробное описание, фото. Бесплатная доставка.',
    ],
    [SETTINGS_SEO_LISTING_TITLE, '[TITLE] купить в официальном интернет-магазине по выгодной цене с доставкой.'],
    [
        SETTINGS_SEO_LISTING_DESCRIPTION,
        '[TITLE] в официальном интернет-магазине по низкой цене. Бесплатная доставка. Акции и скидки. Удобная оплата. Большой ассортимент.',
    ],
    [SETTINGS_SEO_STATIC_TITLE, '[TITLE] | Официальный интернет-магазин.'],
    [
        SETTINGS_SEO_STATIC_DESCRIPTION,
        '[TITLE]. Интернет-магазин. Быстрая доставка, бонусы, скидки и акции, рассрочка и кешбэк. Покупайте товары у нас.',
    ],
]);

export const getSettingsSeoMetaPlaceholder = (id: SettingSeoPaths): string => PLACEHOLDER_MAPPING.get(id) || '';
